export const environment: any = {
    production: true,
    base_url: 'https://idrisesenart.com',
    api_base: 'https://idrisesenart.com/api',
    defaultLang: 'en',
    languages: ['ar', 'en', 'tr'],
    defaultCategory: 'paint',
    gallery: {
        pageSize: 8,
        infiniteScrollDistance: 4.5,
    },

    recaptchaKey: '6LdccS4qAAAAAGi5HCY2woDZ2WX3NtjxZ4-UcNID',
    googleAnalytics: { id: 'G-5WW1CJ19VB', useAnalytics: true },
};
